import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './BlogHead.css';
import logo from '../../assest/images/logoAlbarede.png';
import saudiFlag from '../../assest/images/vecteezy_saudi-arabia-flag-vector_.jpg';
import britishFlag from '../../assest/images/vecteezy_united-kingdom-flag-flag-of-uk-vector_9767148-1.jpg';
import '../../i18n';

/* global google */

function BlogHeader() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function googleTranslate() {
    const script = document.createElement('script');
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);
  
    script.onload = () => {
      try {
        window.googleTranslateElementInit = () => {
          new google.translate.TranslateElement(
            { pageLanguage: 'ar', autoDisplay: false },
            "google_translate_element"
          );
  
          const css = `
            .goog-te-banner-frame { display: none !important; }
            body { top: 0px !important; }
          `;
          const style = document.createElement('style');
          style.type = 'text/css';
          style.appendChild(document.createTextNode(css));
          document.head.appendChild(style);
        };
      } catch (error) {
        console.error('Error initializing Google Translate:', error);
      }
    };
  }
  
  function stopGoogleTranslate() {
    const bannerFrame = document.querySelector('iframe.goog-te-banner-frame');
    if (bannerFrame) bannerFrame.remove();
  
    const translateFrames = document.querySelectorAll('iframe');
    translateFrames.forEach(frame => {
      if (frame.src.includes('translate')) frame.remove();
    });
  
    const translateElement = document.getElementById("google_translate_element");
    if (translateElement) translateElement.innerHTML = "";
  
  }

  const changeLng = (ln) => {
    i18n.changeLanguage(ln);
    const htmlElement = document.getElementById('htmlElement');
    if (htmlElement) {
      if (ln === 'ar') {
        htmlElement.setAttribute('dir', 'rtl');
        setTimeout(stopGoogleTranslate, 500);
      } else if (ln === 'en') {
        htmlElement.setAttribute('dir', 'ltr');
        googleTranslate();
      }
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className={`navbarB ${isScrolled ? 'scrolled' : ''}`}>
        {/* زر الـ Burger للموبايل */}
        <div className={`nav-burger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
{/* الشعار والهوية البصرية */}
        <Link to="/" className="nav-logo">
          <img src={logo} alt="logo albarede" className="logo-img" />
          <div className="logoInfo">
            <h4>{t('company-name')}</h4>
            <span>{t('company-disc')}</span>
          </div>
        </Link>
        {/* روابط التنقل للشاشات الكبيرة */}
        <ul className="nav-links">
          <li><Link to="/" target="_top">{t('headerLi0')}</Link></li>
          <li><a href="/fields">{t('fieldsTitle')}</a></li>
          <li><a href="/team">{t('ourTeam')}</a></li>
          <li><Link to="/articles" target="_top">{t('ourArticles')}</Link></li>
          <li><a href="/laws">{t('rules')}</a></li>
        </ul>

        
        {/* زر الاستشارة الملوّن بالذهبي الفاخر المستوحى من الحداثة */}
        <div className="nav-actions">
          {/* محول اللغات الاحترافي بجانب الزر */}
          <div className="lang-dropdown-wrapper">
            <button className="lang-btn-current">
              <img src={i18n.language === 'en' ? britishFlag : saudiFlag} alt="flag" />
              <span>{i18n.language === 'en' ? 'EN' : 'العربية'}</span>
            </button>
            <ul className="lang-dropdown-menu">
              <li onClick={() => changeLng('ar')}>
                <img src={saudiFlag} alt="Arabic" /> <span>العربية</span>
              </li>
              <li onClick={() => changeLng('en')}>
                <img src={britishFlag} alt="English" /> <span>English</span>
              </li>
            </ul>
          </div>
          <Link to="/askConsults" target="_top" className="nav-cta">
            {t('askYourConsult')}
          </Link>
        </div>

        
      </nav>

      {/* القائمة الجانبية المحدثة للموبايل بقناع زجاجي داكن فاخر */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/" target="_top" onClick={toggleMenu}>{t('headerLi0')}</Link>
        <a href="/fields" onClick={toggleMenu}>{t('fieldsTitle')}</a>
        <a href="/team" onClick={toggleMenu}>{t('ourTeam')}</a>
        <Link to="/articles" target="_top" onClick={toggleMenu}>{t('ourArticles')}</Link>
        <a href="/laws" onClick={toggleMenu}>{t('rules')}</a>
        <a href="#contactUsSec" onClick={toggleMenu}>{t('ContactUs')}</a>
        <Link to="/askConsults" target="_top" className="nav-cta" onClick={toggleMenu}>
          {t('askYourConsult')}
        </Link>
        
        <div className="mobile-lang-switcher">
          <div className="mobile-lang-item" onClick={() => changeLng('ar')}>
            <img src={saudiFlag} alt="AR" /> <span>العربية</span>
          </div>
          <div className="mobile-lang-item" onClick={() => changeLng('en')}>
            <img src={britishFlag} alt="EN" /> <span>English</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogHeader;